<div class="analytics-cards-grid">
  <div class="box t-ac">
    <div class="mt-20">
      <h1>{{ analyticsSearchResult.TotalEmailsSent }}</h1>
    </div>
    <div class="mct-flex mb-15 mct-row mct-items-stretch mct-justify-center mct-items-stretch">
      <img src="/assets/img/email-dashboard/forward_to_inbox.svg" alt="emails sent" />
      <span class="mv-10 ml-10 f-wb">{{ 'communications.mass-comm-message-admin.analytics.emails-sent' | translate | titlecase }}</span>
    </div>
  </div>

  <div class="box t-ac">
    <div class="mt-20">
      <h1>{{ analyticsSearchResult.TotalEmailsOpened }}</h1>
    </div>
    <div class="mct-flex mb-15 mct-row mct-items-stretch mct-justify-center mct-items-stretch">
      <img src="/assets/img/email-dashboard/mark_email_read.svg" alt="emails opened" />
      <span class="mv-10 ml-10 f-wb">{{ 'communications.mass-comm-message-admin.analytics.emails-opened' | translate | titlecase }}</span>
    </div>
  </div>

  <div class="box t-ac">
    <div class="mt-20">
      <h1>{{ analyticsSearchResult.TotalClicks }}</h1>
    </div>
    <div class="mct-flex mb-15 mct-row mct-items-stretch mct-justify-center mct-items-stretch">
      <img src="/assets/img/email-dashboard/web_traffic.svg" alt="clicks" />
      <span class="mv-10 ml-10 f-wb">{{ 'communications.mass-comm-message-admin.analytics.clicks' | translate | titlecase }}</span>
    </div>
  </div>

  <div class="box t-ac">
    <div class="mt-20">
      <h1>{{ analyticsSearchResult.TotalUndeliverables }}</h1>
    </div>
    <div class="mct-flex mb-15 mct-row mct-items-stretch mct-justify-center mct-items-stretch">
      <img src="/assets/img/email-dashboard/sentiment_dissatisfied.svg" alt="undeliverables" />
      <span class="mv-10 ml-10 f-wb">{{ 'communications.mass-comm-message-admin.analytics.undeliverables' | translate | titlecase }}</span>
    </div>
  </div>
</div>
<div class="analytics-two-column-grid mt-50">
  <div>
    <h4>{{ 'communications.mass-comm-message-admin.analytics.top-five-members-grid.heading' | translate | titlecase }}</h4>
    <wl-member-email-engagement-grid [startDate]="startDate" [endDate]="endDate"></wl-member-email-engagement-grid>
  </div>
  <div>
    <h4>{{ 'communications.mass-comm-message-admin.analytics.top-five-links-grid.heading' | translate | titlecase }}</h4>
    <wl-mass-comm-clicked-email-links-grid></wl-mass-comm-clicked-email-links-grid>
  </div>
</div>
<div class="w-100 mt-50">
  <wl-mass-comm-undeliverable-email-grid></wl-mass-comm-undeliverable-email-grid>
</div>
